import React, { useEffect, useState } from 'react'
import { Grid, Badge, Button, useMediaQuery } from '@mui/material'
import { TextBold, TextSemiBold } from '../../../commonComponents/TextStyling'
import JobPost from '../../../commonComponents/JobPost'
import { useNavigate } from 'react-router-dom'
import serverData from '../../../api/ServerData'
import { useDispatch } from 'react-redux'
import { logoutUser } from '../../../actions/loginActions'

import BookmarkAddIcon from '@mui/icons-material/BookmarkAdd'
import { useTheme } from '@mui/material/styles'

export default function Worklist () {
  const [worklistData, setWorklistData] = useState([])
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [loading, setLoading] = useState(true)

  const theme = useTheme()
  const matches = useMediaQuery(theme.breakpoints.down('sm')) // Detect small screens

  useEffect(function () {
    getWorklist()
  }, [])

  function getWorklist () {
    serverData.worklistData(
      {},
      result => {
        if (result.status) {
          setWorklistData(result.response)
        }
        setLoading(false)
      },
      error => {
        setLoading(false)
        if (error.status === 401) {
          dispatch(logoutUser(navigate)) // eslint-disable-next-line
        }
      }
    )
  }

  return (
    <Grid container>
      <Grid item xs={12} style={{ display: 'flex', alignItems: 'center' }}>
        <Grid item xs={9} style={{ display: 'flex' }}>
          <TextBold style={{ fontSize: matches ? '18px' : '24px' }}>
            Jobs In Your Worklist
          </TextBold>
          <Badge
            badgeContent={worklistData?.length}
            color='primary'
            style={{ left: 10 }}
          />
        </Grid>
        <Grid
          item
          xs={3}
          style={{
            display: 'flex',
            justifyContent: 'right'
          }}
        >
          <Button
            onClick={() => navigate('/recruiter/newsearch')}
            style={{ textTransform: 'none' }}
          >
            {matches ? (
              <BookmarkAddIcon />
            ) : (
              <TextSemiBold style={{ fontSize: '16px' }}>
                Add jobs to your worklist
              </TextSemiBold>
            )}
          </Button>
        </Grid>
      </Grid>
      <Grid item xs={12} style={{ marginTop: '24px' }}>
        <JobPost
          data={worklistData}
          loading={loading}
          onReload={() => {
            getWorklist()
          }}
        />
      </Grid>
    </Grid>
  )
}
